export const resolveDefaultExport = value => value?.default ?? value;
